import { Ayah, WordWithSound } from '@app-types/KuranTypes'
import Tooltip from '@components/shared/Tooltip/Tooltip'
import classNames from 'classnames'

export default function LearningQuranAyah({
  isAyahEnd,
  onTriggerWordPlay,
  word,
  hideMeal,
  ayah,
  hideTooltip,
}: {
  isAyahEnd: boolean
  onTriggerWordPlay: (_url: string, _mode?: 'ayah' | 'word') => void
  word: WordWithSound
  hideMeal: boolean
  hideTooltip: boolean
  ayah: Ayah
}) {
  return (
    <div
      onClick={() => {
        isAyahEnd
          ? onTriggerWordPlay(ayah.id?.toString(), 'ayah')
          : onTriggerWordPlay(word.audio_url)
      }}
      className={classNames('ayah mx-1 my-2 text-center', {
        'flex-center': isAyahEnd,
      })}
    >
      <Tooltip
        trigger="click"
        disabled={!hideMeal || hideTooltip}
        content={isAyahEnd ? ayah.translation : word.translation}
        placement="bottom"
      >
        <div
          className={classNames('ayah-arabic my-1 cursor-help hover:text-lime-600', {
            'flex-center  h-10 w-10 rounded-full bg-gray-200 dark:bg-gray-500 ':
              isAyahEnd,
          })}
        >
          <span>{word.arabic}</span>
        </div>
      </Tooltip>
      <div
        className={classNames('ayah-meal', {
          hidden: hideMeal || isAyahEnd,
        })}
      >
        <span>{word.translation}</span>
      </div>
    </div>
  )
}
